import api from "../utils/axiosConfig";
import { USE_MOCK_DATA, mockDelay } from "../utils/mock";

export type LogoutResponse = {
  status: number;
  system: string;
  message: string;
};

export const logoutApi = async (): Promise<LogoutResponse> => {
  if (USE_MOCK_DATA) {
    await mockDelay();
    return { status: 1, system: "auth", message: "Logout successful" };
  }

  try {
    await api.post("/auth/logout");
    return { status: 1, system: "auth", message: "Logout successful" };
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};
